import React, { useEffect } from 'react';
import * as QueryString from 'query-string';

import PageHeader from '../../../support/page-header/PageHeader';
import ReporteFacturacionHitsPorPacList from './components/ReporteFacturacionHitsPorPacList';

const ReporteFacturacionDetalle = (props) => {
  const { id } = props.match.params;

  const query = QueryString.parse(props.location.search);

  const fecha = query.fecha;

  useEffect(() => {
    window.setAppTitle('Facturación detalle');
  }, []);

  const handleOnRowClick = (data) => {
    // TODO sin detalle
  };

  return (
    <div>
      <PageHeader
        text="Facturación"
        to="/admin/reportes/facturacion"
      />

      <ReporteFacturacionHitsPorPacList
        cliente={id}
        fecha={fecha}
        onRowClick={handleOnRowClick}
      />
    </div>
  );
};

export default ReporteFacturacionDetalle;
